import React from "react";
import SearchableCodeSelect from "./SearchableCodeSelect";
import type { CodeOption } from "./SearchableCodeSelect";


export interface CodeMultiSelectProps {
  fetchOptions: (
    searchTerm: string,
    page: number,
    pageSize: number
  ) => Promise<{ data: CodeOption[]; total: number }>;

  value: CodeOption[];
  onChange: (values: CodeOption[]) => void;
minChars?: number;
  placeholder?: string;
  disabled?: boolean;
}


const CodeMultiSelect: React.FC<CodeMultiSelectProps> = ({
  fetchOptions,
  value,
  onChange,
  placeholder = "Search and select codes...",
  disabled = false,
  minChars = 3,
}) => {
  return (
    <div data-testid="CodeMultiSelect-container" style={{ width: "100%" }}>
      <SearchableCodeSelect
        data-testid="CodeMultiSelect-select"
        fetchOptions={fetchOptions}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        disabled={disabled}
        minChars={minChars}
        style={{ width: "100%", marginBottom: 5 }}
      />
    </div>
  );
};

export default CodeMultiSelect;

